import React, { FunctionComponent, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all_with_count, fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
// import { currentPracticeAtom } from '../../../lib/practice';

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import RestoreIcon from '@mui/icons-material/Restore';
import VisibilityIcon from '@mui/icons-material/Visibility';

import {
  Alert,
  Button as Btn,
  Chip,
  DialogActions,
  Divider,
  Grid,
} from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import {
  Button,
  DataGrid,
  Dt,
  IconButton,
  Page,
  TextInput,
  Typography
} from '../../../components/v2/styled';
import { Base } from '../../../components/v2/dialogs/Base';
import { SearchBox } from '../../../components/v2/SearchBox';
import { SnackSaved } from '../../../components/v2/snacks/Saved';

import { User } from '../../../models/User';
import HelpersEhealth from '../../../actions/helpers/ehealth';

// const { DateTime } = require("luxon");

type Props = {}

export const AdminRestrictedList: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  // const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  let count = 0;
  let countDisabled = 0;
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("id DESC");
  const [pageDisabled, setPageDisabled] = useState<number>(0);
  const [orderDisabled, setOrderDisabled] = useState<string>("id DESC");
  const [search, setSearch] = useState<string>("");
  const [filterStatus, setFilterStatus] = useState<number[]>([0, 1]);

  const [savedOpen, setSavedOpen] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [activeRequest, setActiveRequest] = useState<User>();
  const [adminComment, setAdminComment] = useState<string>("");

  const fields = ['id', 'full_name', 'current_sign_in_at', 'email', 'street', 'number', 'zip', 'city', 'country', 'phone_fixed', 'phone_mobile']

  const {
    data: objects,
    isLoading: objectsLoading,
    isError: objectsError,
    isSuccess: objectsSuccess,
    refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["admin", "restricteds", {page: page, order: order, search: search, filterStatus: filterStatus}],
    queryFn: () =>
      fetch_all_with_count<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'restricted',
          fields: [
            'id', 'first_name', 'last_name', 'auth_token', 'email', 'is_admin', 'extra_data', 'get_item_thumb', 'type', 'settings',
            'practice|id/name/item_is_square/get_medium', 'birth_date', 'coach_skills', 'is_agreed_practice', 'current_sign_in_at', 'ehealth',
            'gender', 'street', 'number', 'zip', 'city', 'country|id/name', 'phone_mobile', 'phone_fixed', 'created_at', 'is_public'
          ],
          order: order,
          per_page: 20,
          page: page,
          filter: {
            search: search,
            advanced: {
              admin_only: 1,
              checked: 0
            }
          },
          skip_api_restrictions: 1
        },
        login
      ),
    select: (d) => {
      count = d.count;
      return d.result;
    },
    enabled: !!login,
  });
  const {
    data: objectsDisabled,
    isLoading: objectsDisabledLoading,
    isError: objectsDisabledError,
    isSuccess: objectsDisabledSuccess,
    refetch: objectsDisabledRefetch,
  } = useQuery({
    queryKey: ["admin", "restricteds", "disabled", {page: page, order: order, search: search, filterStatus: filterStatus}],
    queryFn: () =>
      fetch_all_with_count<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'restricted',
          fields: [
            'id', 'first_name', 'last_name', 'auth_token', 'email', 'is_admin', 'extra_data', 'get_item_thumb', 'type', 'settings',
            'practice|id/name/item_is_square/get_medium', 'birth_date', 'coach_skills', 'is_agreed_practice', 'current_sign_in_at', 'ehealth',
            'gender', 'street', 'number', 'zip', 'city', 'country|id/name', 'phone_mobile', 'phone_fixed', 'created_at', 'is_public'
          ],
          order: orderDisabled,
          per_page: 20,
          page: pageDisabled,
          filter: {
            search: search,
            advanced: {
              admin_only: 1,
            }
          },
          skip_api_restrictions: 1
        },
        login
      ),
    select: (d) => {
      countDisabled = d.count;
      return d.result;
    },
    enabled: !!login,
  });







  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setSavedOpen(true);
      setOpen(false);
      setActiveRequest(undefined);
      objectsRefetch();
      objectsDisabledRefetch();
    },
  });








  const columns: GridColDef[] = [
    // { field: 'id', headerName: 'ID', width: 80 },
    { field: 'full_name', headerName: t('admin.models.restricteds.full_name', "Naam"), width: 250, sortable: false },
    { field: 'practice_name', headerName: t('admin.models.restricteds.practice_name', "Praktijk"), width: 250, sortable: false },
    // { field: 'original_name', headerName: t('admin.models.merge_requests.original', "Original"), width: 250, sortable: false },
    // { field: 'copy_name', headerName: t('admin.models.merge_requests.copy', "Copy"), width: 250, sortable: false },
    { field: 'created_at', headerName: t("admin.models.restricteds.created_at", "Aangemaakt"), width: 200, renderCell: params => <>
      <Dt d={params.row.created_at} f="DDD t" />
    </> },
    { field: 'is_agreed_practice', headerName: t("admin.models.restricteds.current_status", "Status"), width: 200, renderCell: params => <>
      {!params.row.is_agreed_practice && <Chip label="open" color="warning" />}
      {!!params.row.is_public && <Chip label="blocked" color="error" sx={{marginLeft: 1}} />}
      {!params.row.is_agreed_practice && params.row.extra_data?.restricted_saved === '1' && <Chip label="ready for check" color="primary" sx={{marginLeft: 1}} />}
    </> },
    { field: 'self_registered', headerName: t('admin.models.restricteds.self_registered', "Zelf aangemeld"), width: 120, sortable: false, renderCell: params => <>
      {params.row.extra_data?.self_register && <CheckIcon />}
      {!params.row.extra_data?.self_register && <CloseIcon />}
    </> },
  ];

  return <Page title={t("admin.menu.restricteds")}>
    <DataGrid
      action_count={1}
      hideCount
      actions={(params) => {
        return (<>
          <IconButton title="View" color="default" onClick={() => {
            setActiveRequest(params.row);
            setOpen(true);
          }}>
            <VisibilityIcon />
          </IconButton>
        </>);
      }}
      objectCount={count}
      getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
      objects={(objects || []).map(u => ({
        ...u,
        full_name: [u.first_name, u.last_name].join(" "),
      }))}
      columns={columns}
      loader={objectsLoading}
      onSortModelChange={(a, b) => {
        let a_0_field:string = a[0].field;
        if (a_0_field === 'name') a_0_field = `last_name ${a[0].sort}, first_name`;
        setOrder([a_0_field, a[0].sort].join(' '));
      }}
      page={page}
      setPage={(p) => {setPage(p);}}
    />

    <DataGrid
      action_count={2}
      hideCount
      actions={(params) => {
        return (<>
          <IconButton title="View" color="default" onClick={() => {
            setActiveRequest(params.row);
            setOpen(true);
          }}>
            <VisibilityIcon />
          </IconButton>
          {!!params.row.is_public && <IconButton title="Unblock" color="default" onClick={() => {
            mutationCustomAction.mutate({
              formData: {
                object: 'restricted',
                class_action: 'custom_api_set_state',
                id: params.row.id,
                pick: 'unblock'
              }
            });
          }}>
            <RestoreIcon />
          </IconButton>}
          {!params.row.is_public && <IconButton title="Block" color="default" onClick={() => {
            mutationCustomAction.mutate({
              formData: {
                object: 'restricted',
                class_action: 'custom_api_set_state',
                id: params.row.id,
                pick: 'block'
              }
            });
          }}>
            <NotInterestedIcon />
          </IconButton>}
        </>);
      }}
      objectCount={countDisabled}
      getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
      objects={(objectsDisabled || []).map(u => ({
        ...u,
        full_name: [u.first_name, u.last_name].join(" "),
      }))}
      columns={columns}
      loader={objectsDisabledLoading}
      onSortModelChange={(a, b) => {
        let a_0_field:string = a[0].field;
        if (a_0_field === 'name') a_0_field = `last_name ${a[0].sort}, first_name`;
        setOrder([a_0_field, a[0].sort].join(' '));
      }}
      page={pageDisabled}
      setPage={(p) => {setPageDisabled(p);}}
    />
    
    <SnackSaved open={savedOpen} setOpen={setSavedOpen} />

    <Base
      name="restricted"
      fullWidth
      maxWidth="xl"
      content={<>
        {!!activeRequest && <Grid container sx={{
          marginTop: -1
        }} spacing={1}>
          <Grid item xs={12}>
            <Alert severity='info'>
              <Typography sx={{fontWeight: 'bold'}}>Naam:</Typography>
              <Typography sx={{paddingLeft: 2}}>{activeRequest.first_name} {activeRequest?.last_name}</Typography>
              <Typography sx={{fontWeight: 'bold'}}>Praktijk:</Typography>
              <Typography sx={{paddingLeft: 2}}>{activeRequest.practice_name}</Typography>
              <Typography sx={{fontWeight: 'bold'}}>Email:</Typography>
              <Typography sx={{paddingLeft: 2}}>{activeRequest.email}</Typography>
            </Alert>
          </Grid>

          <Grid item xs={12} sx={{textAlign: 'center'}}>
            <Typography sx={{fontWeight: 'bold'}}>Telefoon:</Typography>
            {!!activeRequest.phone_mobile && <Typography sx={{paddingLeft: 2}}>{activeRequest.phone_mobile} (mobile)</Typography>}
            {!!activeRequest.phone_fixed && <Typography sx={{paddingLeft: 2}}>{activeRequest.phone_fixed} (fixed)</Typography>}
          </Grid>

          {!!activeRequest.birth_date && <Grid item xs={12} sx={{textAlign: 'center'}}>
            <Typography sx={{fontWeight: 'bold'}}>Geboortedatum:</Typography>
            <Typography sx={{paddingLeft: 2}}>{activeRequest.birth_date}</Typography>
          </Grid>}

          {!!HelpersEhealth.connection_data(activeRequest).ssin && <Grid item xs={12} sx={{textAlign: 'center'}}>
            <Typography sx={{fontWeight: 'bold'}}>RIZIV:</Typography>
            <Typography sx={{paddingLeft: 2}}>{HelpersEhealth.connection_data(activeRequest).ssin}</Typography>
          </Grid>}

          <Grid item xs={12} sx={{textAlign: 'center'}}>
            <Typography sx={{fontWeight: 'bold'}}>Adres:</Typography>
            <Typography sx={{paddingLeft: 2}}>{[
              [activeRequest.street, activeRequest.number].join(" "), 
              [activeRequest.zip, activeRequest.city].join(" "),
              activeRequest.country_name
            ].join(", ")}</Typography>
          </Grid>

          <Grid item xs={12} sx={{textAlign: 'center'}}>
            <Typography variant="caption">Meest recente login</Typography>
            {!!activeRequest.current_sign_in_at && <Typography><Dt d={activeRequest.current_sign_in_at} f="dd/LL/y t" /></Typography>}
          </Grid>

          <Grid item xs={12} sx={{textAlign: 'center'}}>
            <Typography variant="caption">Skills</Typography>
            <Typography variant="body1">{activeRequest.coach_skills.map(skill => skill.name).join("; ")}</Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>
          {!activeRequest.is_agreed_practice && <Grid item xs={6} sx={{textAlign: 'right', paddingRight: 0.5, marginTop: -1}}>
            <Button
              label="Valideren"
              id='pick_yes'
              contained
              onClick={(v) => {
                mutationCustomAction.mutate({
                  formData: {
                    object: 'restricted',
                    class_action: 'custom_api_set_state',
                    id: activeRequest.id,
                    pick: 'validate'
                  }
                });
              }}
              sx={{marginTop: 1}}
            />
          </Grid>}
          {!activeRequest.is_agreed_practice && <Grid item xs={6} sx={{paddingLeft: "12px !important", marginTop: -1}}>
            <Button
              label="Blokkeren"
              id='pick_block'
              contained
              secondary
              onClick={(v) => {
                mutationCustomAction.mutate({
                  formData: {
                    object: 'restricted',
                    class_action: 'custom_api_set_state',
                    id: activeRequest.id,
                    pick: 'block'
                  }
                });
              }}
              sx={{marginTop: 1}}
            />
          </Grid>}

        </Grid>}
      </>}
      actions={<DialogActions sx={{borderTop: '1px solid transparent', borderColor: theme.palette.primary.main}}>
        <Btn
          onClick={(e) => {
            setOpen(false);
          }}
          color="primary"
        >{t("shared.nutri_mail.close", "Sluiten")}</Btn>
      </DialogActions>}
      open={open}
      setOpen={setOpen}
    />
  </Page>;
}
